/**
 * Hinzufügen und Entfernen einer Klasse ab einer bestimmten Scrollposition.
 *
 * Die scrollClass Setzt eine gewünschte Klasse, bei einem gewünschten Element, wenn mehr als eine bestimmte oder
 * flexible Pixel-Anzahl weit nach unten gescrolled wurde. Diese wird wieder entfernt, wenn man außerhalb des Bereiches
 * ist. Die Pixel-Anzahl kann entweder ein fixer Wert sein oder ein Selector, wo automatisch die outerHeight ausgelesen
 * wird. Achtung: Wenn durch die Klasse die Höhe geändert wird, kann das scrollEvent getriggered werden, so dass dann
 * ggf. eine Endlosschleife (hin und her-wackeln) entstehen kann.
 *
 * Die Funktion registriert einen Window Load und einen document scroll Handler
 *
 * Events: window.load || document.ready
 *
 * @param {string} element - Selektor bekommt className gesetzt
 * @param {(string|int)} startHeightOrSelector - Fester Pixelwert oder Selector (outerHeight wird genommen), nachdem
 * die Klasse gesetzt wird beim Herunterscrollen.
 * @param {string} className - Gewünschter Klassenname die das element bekommt
 *
 * @return {undefined}
 */

function nc_initScrollClass(element, startHeightOrSelector, className) {
    var moduleLogger = LoggerManager.get('scroll-class').setPrefix('Element: ' + element);
    moduleLogger.trace('INIT START; startheightOrSelector: ' + startHeightOrSelector + '; className: ' + className);

    // Wenn ein fester Wert übergeben wird, kann sofort ausgeführt werden
    if ($.isNumeric(startHeightOrSelector)) {
        moduleLogger.info('Fester Wert übergeben; Document Ready, Scroll und Resize registrieren');

        // Sofort
        $(document).ready(function () {
            nc_scrollClass(element, startHeightOrSelector, className);
        });

    } else {
        moduleLogger.info('Start-Höhe muss berechnet werden: Window load registrieren');

        // Wenn Bilder etc. geladen
        $(window).load(function () {
            nc_scrollClass(element, startHeightOrSelector, className);
        });

    }

    moduleLogger.info('Scroll und resize registrieren');
    // beim scrollen
    $(window).scroll(function () {
        nc_scrollClass(element, startHeightOrSelector, className);
    });
    // beim resize
    $(window).resize(function () {
        nc_scrollClass(element, startHeightOrSelector, className);
    });
    moduleLogger.info('INIT ENDE');
}

/**
 * @see nc_initScrollClass
 */
function nc_scrollClass(element, startHeightOrSelector, className) {

    /**
     * Höhe berechnen: Wenn der übergebene startHeightOrSelector Parameter eine Zahl ist, wird diese als fixe Höhe genommen,
     * Wenn es ein String ist, wird dieser als Selector verwendet und die outerHeight als Höhe verwendet.
     */
    var height = 0;

    // Höhen ausrechnen
    if ($.isNumeric(startHeightOrSelector)) {
        height = startHeightOrSelector;
    } else if ($.isArray(startHeightOrSelector)) {
        $.each(startHeightOrSelector, function () {
            selector = this;
            if (typeof selector === 'object') {
                selector = this.toString();
            }
            height += $(selector).outerHeight(true);
        });
    } else {
        height = $(startHeightOrSelector).outerHeight(true);
    }


    // Wenn mehr als die ermittelte Höhe gescrollt wurde, wird eine Klasse hinzugefügt. Ansonsten wird diese entfernt.
    if ($(window).scrollTop() > height) {
        $(element).addClass(className);
    } else {
        $(element).removeClass(className);
    }
}